import React from "react";
// import { StripeProvider } from "react-stripe-elements";
import { ThemeProvider } from "theme-ui";
import theme from "./theme";

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>{element}</ThemeProvider>
);
